import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-average-revenue',
  templateUrl: './average-revenue.component.html',
  styleUrls: ['./average-revenue.component.css']
})
export class AverageRevenueComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  @Output() errorEmitter = new EventEmitter();

  loading: boolean = false;

  dataItem = {
    chart: {
      numberPrefix: "R$",
      legendposition: "Right",
      drawanchors: "1",
      showvalues: "0",
      theme: "gammel"
    },
    data: [
      {
        label: "Domingo",
        value: 0,
      },
      {
        label: "Segunda",
        value: 0,
      },
      {
        label: "Terça",
        value: 0,
      },
      {
        label: "Quarta",
        value: 0,
      },
      {
        label: "Quinta",
        value: 0,
      },
      {
        label: "Sexta",
        value: 0,
      },
      {
        label: "Sábado",
        value: 0,
      },
    ]
  };
  width = "100%";
  height = "300";
  type = "splinearea";
  dataFormat = "json";
  dataSource = this.dataItem;


  
  listItem: { label: string, type: number, value: number }[] = [
    { label: "VALOR", type: 0, value: 0},
    { label: "QUANTIDADE", type: 1, value: 1},
  ];
  typeSelected: any = 0;
  orderByQuantity: boolean = false;
  filterStart: any;
  errorApi: boolean = false;
  message: string = "";

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }


  recoverValues(item: any) {
    item === 1
    ? (this.orderByQuantity = true, this.typeSelected = 1)
    : (this.orderByQuantity = false, this.typeSelected = 0)
    this.filterItem(this.filterStart);
  }

  filterItem(item: any) {
    if (item.branch != undefined) {
      this.loading = true;
      let excelInfo: any[] = [];
      this.filterStart = item;
      this.weekdaysReturn(item).subscribe((data: any) => {
        data.dataRow.map((el:any) => {
          if( !this.orderByQuantity){
            this.dataItem.chart.numberPrefix = 'R$';
            if (el.saledatetime_weekday == 1) {
              this.dataItem.data[0].value = el.invoice_value;
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Domingo', 'Valor': 'R$' + el.invoice_value.toString()});
            } else if (el.saledatetime_weekday == 2) {
              this.dataItem.data[1].value = el.invoice_value;
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Segunda', 'Valor': 'R$ ' + el.invoice_value.toString()});
            } else if (el.saledatetime_weekday == 3) {
              this.dataItem.data[2].value = el.invoice_value;
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Terça', 'Valor': 'R$ ' + el.invoice_value.toString()});
            } else if (el.saledatetime_weekday == 4) {
            this.dataItem.data[3].value = el.invoice_value;
               excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Quarta', 'Valor': 'R$ ' + el.invoice_value.toString()});
            } else if (el.saledatetime_weekday == 5) {
              this.dataItem.data[4].value = el.invoice_value;
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Quinta', 'Valor': 'R$ ' + el.invoice_value.toString()});
            } else if (el.saledatetime_weekday == 6) {
              this.dataItem.data[5].value = el.invoice_value;
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Sexta', 'Valor': 'R$ ' + el.invoice_value.toString()});
            } else if (el.saledatetime_weekday == 7) {
              this.dataItem.data[6].value = el.invoice_value;
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Sábado', 'Valor': 'R$ ' + el.invoice_value.toString()});
            }

          }else{
            this.dataItem.chart.numberPrefix = '';
            if (el.saledatetime_weekday == 1) {
              this.dataItem.data[0].value = el.invoice_qty;
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Domingo', 'Qtd':  + el.invoice_qty.toString()});
            } else if (el.saledatetime_weekday == 2) {
              this.dataItem.data[1].value = el.invoice_qty;
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Segunda', 'Qtd':  + el.invoice_qty.toString()});
            } else if (el.saledatetime_weekday == 3) {
              this.dataItem.data[2].value = el.invoice_qty;
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Terça', 'Qtd':  + el.invoice_qty.toString()});
            } else if (el.saledatetime_weekday == 4) {
            this.dataItem.data[3].value = el.invoice_qty;
               excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Quarta', 'Qtd':  + el.invoice_qty.toString()});
            } else if (el.saledatetime_weekday == 5) {
              this.dataItem.data[4].value = el.invoice_qty;
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Quinta', 'Qtd':  + el.invoice_qty.toString()});
            } else if (el.saledatetime_weekday == 6) {
              this.dataItem.data[5].value = el.invoice_qty;
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Sexta', 'Qtd':  + el.invoice_qty.toString()});
            } else if (el.saledatetime_weekday == 7) {
              this.dataItem.data[6].value = el.invoice_qty;
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Sábado', 'Qtd':  + el.invoice_qty.toString()});
            }
            
          }

          
        });
        excelInfo.unshift({});
        localStorage.setItem('average-revenue-sellers', JSON.stringify(excelInfo));
        this.loading = false;
        this.errorApi = false;
      },
      (error) => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_AVERAGE_REVENUE;
        this.formatErrorMensagem(error.message);
      });
    }
  }

  weekdaysReturn(item: any) {
    return this.api.postWeekdaysSellerPanel(item.dataMin, item.dataMax, item.branch);
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataAverageRevenue = [];
    let objectAverageRevenue = localStorage.getItem('average-revenue-sellers');

    objectAverageRevenue != null
      ? (dataAverageRevenue = JSON.parse(objectAverageRevenue))
      : (dataAverageRevenue = []);
    const worksheetAverageRevenue= XLSX.utils.json_to_sheet(dataAverageRevenue);

    const workbook = {
      Sheets: {
        'average-revenue': worksheetAverageRevenue,
      },
      SheetNames: [
        'average-revenue',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-average-revenue' + EXCEL_EXTENSION);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: average-revenue \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
